import { useEffect, useState } from 'react'
import { toDayKey } from '../utils/dayKey'

/**
 * Today's day key, re-read as the day turns.
 *
 * A till or a waiter's phone stays open for a whole service, and a component
 * that computed `toDayKey()` once at mount kept watching the day it started
 * on. Past midnight, or on a device left open since an earlier day,
 * that meant a waiter's screen still listing tickets from a day the till had
 * already moved on from, each device convinced the other was wrong.
 *
 * Polled rather than scheduled for the exact moment: a timer set for
 * midnight is thrown off by the device sleeping through it, which is the
 * normal state of a phone in someone's pocket. A minute's granularity is
 * far finer than anything that depends on it.
 */
export function useDayKey(): string {
  const [day, setDay] = useState(toDayKey)

  useEffect(() => {
    const id = setInterval(() => {
      const now = toDayKey()
      // Only ever sets when it actually changed, so this does not re-render
      // every minute for the sake of an identical string.
      setDay((current) => (current === now ? current : now))
    }, 60_000)
    return () => clearInterval(id)
  }, [])

  return day
}
